import z from 'zod';
import { AuthorDtoSchema } from '../author/author.schema';
import { MediaDtoSchema } from '../media/media.schema';
import { createUpdateZodSchema } from '../types/DateUtils.types';

// #region FAQ
export const FaqDtoSchema = z.object({
  id: z.string().uuid(),
  question: z.string(),
  answer: z.string(),
  order: z.number(),
  pageContentId: z.string().uuid(),
}).merge(createUpdateZodSchema);

export type FaqDto = z.output<typeof FaqDtoSchema>;
// #endregion

// #region page meta
export const PageMetaDtoSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  pageId: z.string().uuid(),
  description: z.string().nullable(),
  ogImageId: z.string().uuid().nullable(),
  twitterImageId: z.string().uuid().nullable(),
  ogImage: MediaDtoSchema.nullable(),
  twitterImage: MediaDtoSchema.nullable(),
}).merge(createUpdateZodSchema);

export type PageMetaDto = z.output<typeof PageMetaDtoSchema>;
// #endregion page meta

// #region Page Content
export const PageContentDtoSchema = z.object({
  id: z.string().uuid(),
  body: z.string().nullish(),
  title: z.string().nullish(),
  description: z.string().nullish(),

  pageMeta: PageMetaDtoSchema.nullish(),
  faqs: z.array(FaqDtoSchema).nullable(),
  authorId: z.string().uuid().nullish(),

  author: AuthorDtoSchema.nullish(),
}).merge(createUpdateZodSchema);

export type PageContentDto = z.output<typeof PageContentDtoSchema>;
// #endregion Page Content

// #region System Page
export const SystemPageDtoSchema = z.object({
  id: z.string().uuid(),
  alias: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  body: z.string(),
  faqs: z.array(FaqDtoSchema).nullable(),
  pageMeta: PageMetaDtoSchema.nullable(),

  authorId: z.string().uuid().nullish(),
  author: AuthorDtoSchema.nullish(),
}).merge(createUpdateZodSchema);
export type SystemPageDto = z.output<typeof SystemPageDtoSchema>;
// #endregion System Page
